import type { HomePageControllerLocal } from "./domain/home-page/types";
import { useHomePageControllerHandlers } from "./useHomePageControllerHandlers";
import { useHomePageRuntime } from "./useHomePageRuntime";
import type { LandingPrepageState } from "./useLandingPrepage";

type HomePageControllerHandlersLocal = ReturnType<
  typeof useHomePageControllerHandlers
>;
type HomePageRuntimeLocal = ReturnType<typeof useHomePageRuntime>;

interface GetHomePageControllerInput {
  footerHandlers: Pick<
    HomePageControllerLocal,
    "handleAboutUsClick" | "handleContactClick" | "handleRevealEmailClick"
  >;
  handlers: HomePageControllerHandlersLocal;
  prepageState: LandingPrepageState;
  runtime: HomePageRuntimeLocal;
}

export function getHomePageController({
  footerHandlers,
  handlers,
  prepageState,
  runtime,
}: GetHomePageControllerInput): HomePageControllerLocal {
  const { modalState } = runtime;

  return {
    handleAboutUsClick: footerHandlers.handleAboutUsClick,
    handleAllTeamsClick: handlers.handleAllTeamsClick,
    handleAuthorizeClick: handlers.handleAuthorizeClick,
    handleBuildYourOwnTeam: handlers.handleBuildYourOwnTeam,
    handleCloseAuthModal: handlers.handleCloseAuthModal,
    handleClosePricingModal: handlers.handleClosePricingModal,
    handleCloseTeamsModal: handlers.handleCloseTeamsModal,
    handleContactClick: footerHandlers.handleContactClick,
    handleHeroTeamDeploy: handlers.handleHeroTeamDeploy,
    handleHeroTeamDetailsOpen: handlers.handleHeroTeamDetailsOpen,
    handlePricingClick: handlers.handlePricingClick,
    handlePricingPlanAccess: handlers.handlePricingPlanAccess,
    handleQuickStart: handlers.handleQuickStart,
    handleGalleryQuickStart: handlers.handleGalleryQuickStart,
    handleReplicateTeam: handlers.handleReplicateTeam,
    handleRevealEmailClick: footerHandlers.handleRevealEmailClick,
    handleStartNewSession: handlers.handleStartNewSession,
    handleTeamsModalLoginRequest: handlers.handleTeamsModalLoginRequest,
    hasOpenedPricingModal: modalState.hasOpenedPricingModal,
    hasOpenedTeamDetailsModal: modalState.hasOpenedTeamDetailsModal,
    hasOpenedTeamsModal: modalState.hasOpenedTeamsModal,
    hasProfileError: runtime.hasProfileError,
    isTeamGalleryCoveredByDetails: modalState.isTeamGalleryCoveredByDetails,
    openTeamDetails: handlers.openTeamDetails,
    openUserMenuRequestId: runtime.openUserMenuRequestId,
    pricingAccessLoadingPlanKey: modalState.pricingAccessLoadingPlanKey,
    profileImageSrc: runtime.profileImageSrc,
    shouldHideNavbar: runtime.navbarState.shouldHideNavbar,
    showAuthModal: modalState.showAuthModal,
    showNonLoggedNavbar: runtime.navbarState.showNonLoggedNavbar,
    showPrepage: prepageState.showPrepage,
    showPricingModal: modalState.showPricingModal,
    showTeamDetailsModal: modalState.showTeamDetailsModal,
    showTeamsModal: modalState.showTeamsModal,
    teamDetailsTeamId: modalState.teamDetailsTeamId,
  };
}
